<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Slogan/título Home
            </h3>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="home_title"
              :counter="200"
              :maxlength="200"
              outlined
              label="Slogan/título Home"
            ></v-text-field>
          </v-col>

          <v-col 
            cols="12" 
            xl="6" 
            md="5" 
            sm="12">
            <h3 class="font-weight-regular">Color de texto:</h3>
            <v-radio-group v-model="home_title_dark_mode">
              <v-radio
                label="Blanco"
                :value="true"
              ></v-radio>

              <v-radio
                label="Negro"
                :value="false"
              ></v-radio>

            </v-radio-group>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Imagen HOME:</h3>
          </v-col>

          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!home_image"
              v-model="home_image"
              :rules="rules"
              @change="onImageHomeChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen HOME"
              :messages="['Para una mejor visualización, usar un imagen cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="home_image"
              wei>
              <v-img
                contain
                :src="url_home_image"
                class="grey lighten-2"
                height="440px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteImageHome()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Logo HOME:</h3>
          </v-col>

          <v-col cols="12" align="center">
            <v-file-input
              outlined
              v-if="!home_logo"
              v-model="home_logo"
              :rules="rules"
              @change="onLogoHomeChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Logo HOME"
              :messages="['Para una mejor visualización, usar un imagen de 380x520 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>
        
            <v-card
              v-if="home_logo"
              max-width="380px">
              <v-img
                contain
                :src="url_home_logo"
                max-width="380px"
                max-height="520px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteLogoHome()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="4" md="4" sm="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Boton Auditorio
            </h3>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-file-input
              outlined
              v-if="!auditorium_button"
              v-model="auditorium_button"
              :rules="rules"
              @change="onAuditoriumButtonChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Boton Auditorio"
              :messages="['Para una mejor visualización, usar una imagen de como máximo 240x240 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="auditorium_button"
              width="240">
              <v-img
                contain
                :src="url_auditorium_button"
                width="240px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteAuditoriumButton()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="4" md="4" sm="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Boton Galeria de Proyectos
            </h3>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-file-input
              outlined
              v-if="!project_gallery_button"
              v-model="project_gallery_button"
              :rules="rules"
              @change="onProjectGalleryButtonChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Boton Auditorio"
              :messages="['Para una mejor visualización, usar una imagen de como máximo 240x240 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="project_gallery_button"
              width="240">
              <v-img
                contain
                :src="url_project_gallery_button"
                width="240px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteProjectGalleryButton()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="4" md="4" sm="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Boton Programa
            </h3>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-file-input
              outlined
              v-if="!program_button"
              v-model="program_button"
              :rules="rules"
              @change="onProgramButtonChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Boton Programa"
              :messages="['Para una mejor visualización, usar una imagen de como máximo 240x240 px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="program_button"
              width="240">
              <v-img
                contain
                :src="url_program_button"
                width="240px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteProgramButton()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >

        <v-col class="pl-4" cols="12">
          <h3 class="font-weight-regular">Tipo de HOME: {{ home_selected }}</h3>
        </v-col>
          
        <v-radio-group v-model="home_selected">
          <v-row class="pa-4">
            <v-col 
              cols="12" 
              xl="3"
              md="3"
              sm="12"
              align="center">
              <v-card>
                <v-img
                  class="pt-8"
                  contain
                  :src="require('@/assets/img/home1.png')"
                  max-width="120px"
                  max-height="300px"
                >
                </v-img>

                <v-card-actions class="d-flex justify-center mb-6">
                  <v-radio
                    label="HOME 1"
                    value="1"
                  ></v-radio>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col 
              cols="12" 
              xl="3"
              md="3"
              sm="12"
              align="center">
              <v-card>
                <v-img
                  class="pt-8"
                  contain
                  :src="require('@/assets/img/home2.png')"
                  max-width="120px"
                  max-height="300px"
                >
                </v-img>

                <v-card-actions class="d-flex justify-center mb-6">
                  <v-radio
                    label="HOME 2"
                    value="2"
                  ></v-radio>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col 
              cols="12" 
              xl="3"
              md="3"
              sm="12"
              align="center">
              <v-card>
                <v-img
                  class="pt-8"
                  contain
                  :src="require('@/assets/img/home3.png')"
                  max-width="120px"
                  max-height="300px"
                >
                </v-img>

                <v-card-actions class="d-flex justify-center mb-6">
                  <v-radio
                    label="HOME 3"
                    value="3"
                  ></v-radio>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col 
              cols="12" 
              xl="3"
              md="3"
              sm="12"
              align="center">
              <v-card>
                <v-img
                  class="pt-8"
                  contain
                  :src="require('@/assets/img/home4.png')"
                  max-width="120px"
                  max-height="300px"
                >
                </v-img>

                <v-card-actions class="d-flex justify-center mb-6">
                  <v-radio
                    label="HOME 4"
                    value="4"
                  ></v-radio>
                </v-card-actions>
              </v-card>
            </v-col>

          </v-row>
        </v-radio-group>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'customizationEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationEdition()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="error"
      persistent
      max-width="480"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                style="white-space: normal; word-break: break-word;"
                class="pt-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationEdition',
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      
      customization:[],

      home_selected: "1",

      home_title:null,
      home_title_dark_mode: true,
      home_image: null,
      url_home_image: null,

      home_logo: null,
      url_home_logo: null,

      auditorium_button: null,
      url_auditorium_button: null,  

      project_gallery_button: null,
      url_project_gallery_button: null,  
      
      program_button: null,
      url_program_button: null,  

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.edition = response.data.data
          this.customization = response.data.data.customization

          this.home_selected = response.data.data.customization.home_selected.toString()

          this.home_title = (response.data.data.customization.home_title==null)?'':response.data.data.customization.home_title
          this.home_title_dark_mode = (response.data.data.customization.home_title_dark_mode)?true:false
          
          this.home_image = response.data.data.customization.home_image
          this.url_home_image = APP_URL+ this.home_image

          this.home_logo = response.data.data.customization.home_logo
          this.url_home_logo = APP_URL+ this.home_logo

          this.auditorium_button = response.data.data.customization.auditorium_button
          this.url_auditorium_button = APP_URL+ this.auditorium_button

          this.project_gallery_button = response.data.data.customization.project_gallery_button
          this.url_project_gallery_button = APP_URL+ this.project_gallery_button

          this.program_button = response.data.data.customization.program_button
          this.url_program_button = APP_URL+ this.program_button

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true

        let formData= new FormData()
        formData.append('home_selected', this.home_selected)
        formData.append('home_title', this.home_title)
        formData.append('home_title_dark_mode', this.home_title_dark_mode? 1 : 0)
        formData.append('home_image', this.home_image)
        formData.append('home_logo', this.home_logo)
        formData.append('auditorium_button', this.auditorium_button)
        formData.append('project_gallery_button', this.project_gallery_button)
        formData.append('program_button', this.program_button)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization-home',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
          this.loading_update=false
          this.error = true
          this.errors = Object.values(error.response.data.errors).flat()
        }
      },

      //----Backgound Home----
      onImageHomeChange() {
        this.url_home_image = URL.createObjectURL(this.home_image);
      },

      deleteImageHome(){
        this.home_image=null
        this.url_home_image=null
      },

      //----Logo----
      onLogoHomeChange() {
        this.url_home_logo = URL.createObjectURL(this.home_logo);
      },

      deleteLogoHome(){
        this.home_logo=null
        this.url_home_logo=null
      },

      //----Auditorium----
      onAuditoriumButtonChange() {
        this.url_auditorium_button = URL.createObjectURL(this.auditorium_button);
      },

      deleteAuditoriumButton(){
        this.auditorium_button=null
        this.url_auditorium_button=null
      },

      //----Project Gallery----
      onProjectGalleryButtonChange() {
        this.url_project_gallery_button = URL.createObjectURL(this.project_gallery_button);
      },

      deleteProjectGalleryButton(){
        this.project_gallery_button=null
        this.url_project_gallery_button=null
      },

      //----Program----
      onProgramButtonChange() {
        this.url_program_button = URL.createObjectURL(this.program_button);
      },

      deleteProgramButton(){
        this.program_button=null
        this.url_program_button=null
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getCustomization()
    },
  }
</script>
